import GalleryControl from './gallery-control';


export default (di) => {
	di
		.setType({type: GalleryControl, name: 'GalleryControl', parent: 'PageComponent'})
	;
};
